export enum RequestAddressErrorMessage {
  COVERAGE = 'coordenadas',
  INVALID = 'válida',
}
